/**
 * Canonical app route prefixes for partner portals.
 * Keep legacy redirects in App.js for bookmarks.
 */

export const ROUTES = Object.freeze({
  partnerLogin: '/partner/login',
  support: '/eats/support',

  // Maya Eats Business (EAP)
  admin: '/eats/admin',
  adminDashboard: '/eats/admin',
  adminEmployees: '/eats/admin/employees',
  adminRestaurants: '/eats/admin/restaurants',
  adminRestaurantsCreate: '/eats/admin/restaurants/create',
  adminRestaurantById: (id) => `/eats/admin/restaurants/${id}`,
  adminOrganizationsCreate: '/eats/admin/organizations/create',
  adminOrganizationById: (id) => `/eats/admin/organizations/${id}`,
  adminStoresCreate: '/eats/admin/stores/create',
  adminStoreById: (id) => `/eats/admin/stores/${id}`,
  user: '/eats/user',
  userProfile: '/eats/user/profile',

  // Restaurant / Store business portal
  businessAdmin: '/business/admin',
  businessUser: '/business/user',
  businessProfile: '/business/user/profile',

  // Organization portal
  organizationAdmin: '/organization/admin',
  organizationUser: '/organization/user',
});

/** Build /eats/support URL with optional type + business name defaults. */
export function supportUrl({ type, name } = {}) {
  const params = new URLSearchParams();
  if (type) params.set('type', String(type));
  if (name) params.set('name', String(name));
  const query = params.toString();
  return query ? `${ROUTES.support}?${query}` : ROUTES.support;
}

export function adminDashboardTab(tab) {
  if (!tab) return ROUTES.admin;
  return `${ROUTES.admin}?tab=${encodeURIComponent(tab)}`;
}

export function businessAdminTab(tab) {
  if (!tab) return ROUTES.businessAdmin;
  return `${ROUTES.businessAdmin}?tab=${encodeURIComponent(tab)}`;
}
